// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('stock.productReports', {
        url: '/productreports',
        views: {
            "wideColumnView@stock": {
                templateUrl: 'main/stock/reports/productReports.tpl.html',
                controller: 'ProductReportsController as vm'
            }
        }
    });
}

// @ngInject
function ProductReportsController(StockApiService, $window, loadSpinnerService, ToasterService, $translate) {
    var vm = this;

    vm.printLanguage = 'se';
    vm.includeExternalId = false;
    vm.includeBarcode = false;
    vm.groupingLevels = [
        { name: 'grouping.variant1', value: 'articleVariant1Level' },
        { name: 'grouping.variant2', value: 'articleVariant1Variant2Level' }
    ];

    vm.getProductReport = getProductReport;

    activate();

    function activate() {
        vm.selectedGroupingLevel = _.find(vm.groupingLevels, function(o) { return o.value === 'articleVariant1Level'; });
        readSettingsFromLocalStorage();
    }

    function getProductReport() {
        var request = {
            languageCode: vm.printLanguage,
            level: vm.selectedGroupingLevel.value,
            includeExternalId: vm.includeExternalId,
            includeBarcode: vm.includeBarcode
        };

        loadSpinnerService.start("mainSpinner");
        saveSettingsToLocalStorage();

        StockApiService.downloadProductReport(request).then(function () {
            ToasterService.showSuccess($translate.instant('reports.ui.productreport') + ' ' + $translate.instant('common.created'), $translate.instant('common.stock'));
        }, function (error) {
            if (error.errors) {
                vm.validationErrors = error.errors;
            }
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function saveSettingsToLocalStorage() {
        var settings = {
            languageCode: vm.printLanguage,
            groupingLevel: vm.selectedGroupingLevel.value,
            includeExternalId: vm.includeExternalId,
            includeBarcode: vm.includeBarcode
        };
        $window.localStorage.setItem('printProductReportSettings', JSON.stringify(settings));
    }

    function readSettingsFromLocalStorage() {
        if ($window.localStorage.printProductReportSettings) {
            if (!isJsonString($window.localStorage.getItem('printProductReportSettings'))) {
                $window.localStorage.removeItem('printProductReportSettings');
            }
            var settingsStr = $window.localStorage.getItem('printProductReportSettings');
            if (settingsStr !== null) {
                var json = JSON.parse(settingsStr);
                if (json.languageCode) { vm.printLanguage = json.languageCode; }
                if (json.groupingLevel) { vm.selectedGroupingLevel = _.find(vm.groupingLevels, function(o) { return o.value === json.groupingLevel; }); }
                if (json.includeExternalId) { vm.includeExternalId = json.includeExternalId; }
                if (json.includeBarcode) { vm.includeBarcode = json.includeBarcode; }
            }
        }
    }

    function isJsonString(str) {
        try {
            JSON.parse(str);
        } catch (e) {
            return false;
        }
        return true;
    }
}

angular.module('stock.productReports', [])
    .config(stateConfig)
    .controller('ProductReportsController', ProductReportsController);
